import * as React from 'react';
import {
  CompactFooterContainer,
  CompactFooterContent,
  CompactFooterLink,
} from '../../components/UI/CompactFooterUI';
import Routes from '../../constants/Routes';

const CompactFooter: React.SFC = () => (
  <CompactFooterContainer>
    <CompactFooterContent>
      <div>
        <ul>
          <li>&copy; 2018 Coinmend</li>
          <li>
            <CompactFooterLink to={Routes.about}>About</CompactFooterLink>
          </li>
          <li>
            <CompactFooterLink to={Routes.privacy}>Privacy</CompactFooterLink>
          </li>
          <li>
            <CompactFooterLink to={Routes.terms}>Terms</CompactFooterLink>
          </li>
        </ul>
      </div>
    </CompactFooterContent>
  </CompactFooterContainer>
);

export default CompactFooter;



// WEBPACK FOOTER //
// ./src/containers/Site/CompactFooter.tsx